import { ApolloError } from "apollo-client";
import { useCallback } from "react";
import { ExecutionResult, useMutation } from "react-apollo";
import CartProductAdd from "src/hoc/persister/cartProductAdd/graphql/CartProductAdd";
import { ICart, ICartProductAddInput } from "src/types/cart";

interface IVariables {
  input: ICartProductAddInput;
}

interface ICartProductAdd {
  cartProductAdd: ({
    productId,
    quantity,
  }: ICartProductAddInput) => Promise<ExecutionResult<ICart>>;
  data?: ICart;
  cartProductAddLoading: boolean;
  cartProductAddError?: ApolloError;
}

export const useCartProductAdd = (): ICartProductAdd => {
  const mutationResult = useMutation<ICart, IVariables>(CartProductAdd);

  const [mutation, { data, loading, error }] = mutationResult;

  const cartProductAdd = useCallback(
    async ({
      productId,
      quantity,
    }: ICartProductAddInput): Promise<ExecutionResult<ICart>> => {
      const variables = { input: { productId, quantity } };
      const res = await mutation({ variables });

      return res;
    },
    [mutation]
  );

  // console.log("[mutationResult]", mutationResult);

  return {
    cartProductAdd,
    cartProductAddLoading: loading,
    cartProductAddError: error,
  };
};
